import { fetchInstance } from '@/utils/fetchInstance';

export interface CdnVideo {
  name: string;
  size: number;
  mtime: number;
}

export const getCdnVideos = (): Promise<CdnVideo[]> =>
  fetchInstance.get<CdnVideo[]>('videos');
